import * as yup from 'yup';

// eslint-disable-next-line no-template-curly-in-string
const MAX_LENGTH_MESSAGE = 'Must be between 1 and ${max} characters';

const createNameValidator = fieldName => yup.string()
  .trim()
  .required(`Please enter your ${fieldName}`)
  .matches(
    /^[A-Za-zÀ-öø-ÿ][A-Za-zÀ-öø-ÿ' -]*$/,
    "This field only accepts letters and ' - and must start with a letter"
  )
  .max(25, MAX_LENGTH_MESSAGE);

export default createNameValidator;
